module.exports = __webpack_public_path__ + "assets/img/icon_voice.96eee8c5.svg";